import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AfterViewInit, Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "s3-image",
  template:
    '<img loading="lazy" [class]="class" [style]="style" [src]="src" [alt]="alt"/>',
})
export class S3Image implements OnInit, AfterViewInit {
  @Input() src: string;
  @Input() alt = "";
  @Input() class = "";
  @Input() style = "";
  copySrc: string = "";
  constructor(private http: HttpClient) {}
  ngOnInit(): void {
    this.copySrc = this.src;

    this.src = "/assets/loading.gif";
  }

  ngAfterViewInit(): void {
    const headers = new HttpHeaders({
      "X-access-token": localStorage.getItem("acc_tok"),
    });
    this.http
      .get(this.copySrc + "&type=link", { headers })
      .subscribe((val: any) => {
        this.src = val.link;
      });
  }
}
